import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '../../api';

@Injectable({
    providedIn: 'root'
})
export class CompositeService {
    private url: string = API + '/composite';

    constructor(private http: HttpClient) { }

    encodeQuery(params: any): string {
        return Object.keys(params).map((key) => {
            return [key, params[key]].map(encodeURIComponent).join('=');
        }).join('&');
    }

    getComposites(params?: any): Observable<any> {
        let query = '';
        if(params) {
            query += '?';
            query += this.encodeQuery(params);
        }
        return this.http.get(`${this.url}${query}`);
    }

    getComposite(id: number): Observable<any> {
        return this.http.get(`${this.url}/${id}`);
    }

    createComposite(composite: any): Observable<any> {
        return this.http.post(this.url, composite);
    }

    deleteComposite(id: number): Observable<any> {
        return this.http.delete(`${this.url}/${id}`);
    }

    getStates(): Observable<any> {
        return this.http.get(`${this.url}/state`);
    }
}
